import React, { createRef, useState } from 'react';
import { Button } from 'reactstrap';
import Dropzone, { DropzoneRef } from 'react-dropzone';
import CroppingToolPopup from '../../../../../../components/CroppingToolPopup/CroppingToolPopup';
import ReactSwitch from 'react-switch';
import './HistoricalGrowthMap.scss';
import uploadArrow from '../../../../../../assets/images/uploadArrow.png';
import ConfirmationModal from '../../../../../../components/Modal/ConfirmationModal';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faTrashCan } from '@fortawesome/free-solid-svg-icons';

interface HistoricalGrowthMapProps {
    growthMapUrl: string;
    shouldRemoveGrowthMapData: boolean;
    setGrowthMapData: (formData: FormData) => void;
    setShouldRemoveGrowthMapData: (shouldRemove: boolean) => void;
}

export const HistoricalGrowthMap = (props: HistoricalGrowthMapProps) => {
    const [isUploadImagePopupVisible, setIsUploadImagePopupVisible] =
        useState(false);
    const [selectedMapFile, setSelectedMapFile] = useState<File>(null);

    const [previewGrowthMap, setPreviewGrowthMap] = useState<string | null>(
        null
    );
    const dropzoneRef = createRef<DropzoneRef>();
    const allowedImageExtensions = ['.jpg', '.jpeg', '.png', '.gif'];
    const openUploadDialog = () => {
        if (dropzoneRef.current) {
            dropzoneRef.current.open();
        }
    };
    const [
        isConfirmationMapRemovalVisible,
        setIsConfirmationMapRemovalVisible,
    ] = useState<boolean>(false);
    const renderMapUpload = () => (
        <div className="image-container">
            <div className="upload-image-container">
                <div className="label-container">
                    <label>
                        Upload an image or opt to use the historical growth map.
                    </label>
                    <div className="switch-container">
                        <label>Use historical growth map</label>
                        <ReactSwitch
                            offColor="#d92550"
                            checked={true}
                            onChange={() => {}}
                            height={22}
                        />
                        <label>Upload a file</label>
                    </div>
                </div>
                <div className="upload-image-wrapper">
                    <div>
                        <div className="upload-box">
                            <Dropzone
                                noClick
                                noKeyboard
                                ref={dropzoneRef}
                                onDrop={(acceptedFiles: File[]) => {
                                    setSelectedMapFile(acceptedFiles[0]);
                                    setIsUploadImagePopupVisible(true);
                                }}
                                accept={{
                                    'image/jpeg': allowedImageExtensions,
                                }}>
                                {({ getRootProps, getInputProps }) => {
                                    return (
                                        <div>
                                            <div
                                                {...getRootProps({
                                                    className: 'dropzone',
                                                })}>
                                                <input
                                                    {...getInputProps()}
                                                    accept={allowedImageExtensions.join(
                                                        ','
                                                    )}
                                                />
                                                <div>
                                                    <img src={uploadArrow} />
                                                </div>
                                                <Button
                                                    className="btn btn-primary upload-btn"
                                                    color="primary"
                                                    onClick={() =>
                                                        openUploadDialog()
                                                    }>
                                                    Upload
                                                </Button>
                                            </div>
                                        </div>
                                    );
                                }}
                            </Dropzone>
                        </div>
                    </div>
                    <div className="preview-image-container">
                        {props.shouldRemoveGrowthMapData ? (
                            <div className="empty-logo-area">
                                There is no historical map uploaded yet
                            </div>
                        ) : previewGrowthMap ? (
                            <img src={previewGrowthMap} alt="Logo Preview" />
                        ) : props.growthMapUrl ? (
                            <img src={props.growthMapUrl} alt="Current Logo" />
                        ) : (
                            <div className="empty-logo-area">
                                There is no historical map uploaded yet
                            </div>
                        )}
                        {(props.growthMapUrl || previewGrowthMap) &&
                        !props.shouldRemoveGrowthMapData ? (
                            <div className="remove-image-container">
                                <FontAwesomeIcon
                                    className="delete-button"
                                    onClick={() => {
                                        setIsConfirmationMapRemovalVisible(
                                            true
                                        );
                                    }}
                                    icon={faTrashCan}
                                />
                            </div>
                        ) : (
                            <></>
                        )}
                    </div>
                </div>
            </div>
        </div>
    );

    const changeGrowthMap = (file: File, fileUrl: string) => {
        setPreviewGrowthMap(fileUrl);
        props.setShouldRemoveGrowthMapData(false);
        const formData = new FormData();
        formData.append('File', file);
        formData.append('Url', fileUrl);
        props.setGrowthMapData(formData);
    };

    return (
        <div className="historical-growth-map">
            {renderMapUpload()}
            {isUploadImagePopupVisible && (
                <CroppingToolPopup
                    initialAspect={2 / 1}
                    header="Upload Logo"
                    isVisible={isUploadImagePopupVisible}
                    close={() => setIsUploadImagePopupVisible(false)}
                    apply={(croppedFile, croppedImage) => {
                        changeGrowthMap(croppedFile, croppedImage);
                    }}
                    preSelectedFile={selectedMapFile}
                />
            )}
            {isConfirmationMapRemovalVisible && (
                <ConfirmationModal
                    isVisible={isConfirmationMapRemovalVisible}
                    setIsVisible={() => {
                        setIsConfirmationMapRemovalVisible(false);
                    }}
                    header={'Are you sure?'}
                    confirmationText={
                        'Are you sure you want to delete growth map?'
                    }
                    onConfirm={() => {
                        props.setShouldRemoveGrowthMapData(true);
                        setPreviewGrowthMap(null);
                        props.setGrowthMapData(null);
                    }}
                    params={undefined}
                    cancelButtonText={'No, take me back'}
                    nextButtonText={`Yes, I'm sure`}></ConfirmationModal>
            )}
        </div>
    );
};
